(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("PracticalEvaluationHistoryFilesCtrl", ["practicalEvaluationHistoryResource", "assignmentLearnerAccessPracticalEvaluationResource", "$state", practicalEvaluationHistoryFilesCtrl]);
    function practicalEvaluationHistoryFilesCtrl(practicalEvaluationHistoryResource, assignmentLearnerAccessPracticalEvaluationResource, $state) {
        var vm = this;
        vm.loading = true;
        vm.number = $state.params.number;
        vm.version = $state.params.version;
        vm.code = $state.params.code;
        vm.activationNumber = $state.params.activationNumber;
        vm.person = $state.params.person;
        vm.assignmentId = $state.params.assignmentId;
        if (vm.person) {
            //Admin View of Learner Files
            practicalEvaluationHistoryResource.getFiles({ code: vm.code, person: vm.person, assignmentId: vm.assignmentId, activationNumber: vm.activationNumber }, function (data) {
                vm.practicalEvaluationFiles = data;
                vm.loading = false;
            });
        }
        else {
            //Learner View of Files
            assignmentLearnerAccessPracticalEvaluationResource.getLearnerAccessHistoryFilesViewModel({ number: vm.number, version: vm.version, code: vm.code, activationNumber: vm.activationNumber }, function (data) {
                vm.practicalEvaluationFiles = data;
                vm.loading = false;
            });
        }
    }
}());
